export default {
  1337: "all fine",
  2000: "Der Benutzername wird bereits verwendet",
  2010: "Der Benutzername ist zu lang oder zu kurz",
  2015: "Bitte gib deinen Benutzernamen und Passwort an.",
  2020: "Der Benutzername enthält Sonderzeichen",
  2030: "Dieser Benutzername ist geblockt",
  2040: "Der Code ist nicht vier Zeichen lang",
  2050: "Der Code enthält unzulässige Zeichen",
  2060: "Zu ihrer Sitzung konnte kein Token gefunden werden. Kehren Sie bitte zu bad.schallerbach.at/ zurück um mit der Registrierung eines Nutzers zu beginnen!",
  2070: "Zu ihrer Sitzung konnte kein Token gefunden werden. Kehren Sie bitte zu bad.schallerbach.at/ zurück um mit der Verknüpfung eines Nutzers zu beginnen!",
  2100: "Falsches Passwort",
  2110: "Der Benutzername ist nicht vergeben",
  4000: "general error",
  4010: "Json parse error",
  4020: "Unusual response",
  4050: "no server to communicate with",
  5000: "Database error"
};
